module.exports = __webpack_public_path__ + "media/images/mamari/wowma/attention-c949aacc5e3a0fc5140d013021fbc9e1.png";